module.exports = __webpack_public_path__ + "static/media/coffee-promo-dt-fr.e83a5e31.jpg";